<template>
  <div class="columns is-multiline">
    <div
      v-for="(dish, index) in dishes"
      :key="index"
      class="column is-one-third"
    >
      <div class="card">
        <div class="card-image">
          <figure class="image is-4by3">
            <img :src="dish.image" :alt="dish.name" />
          </figure>
        </div>
        <div class="card-content">
          <div class="media">
            <div class="media-content">
              <p class="title is-4">{{ dish.name }}</p>
              <p class="subtitle is-6">{{ format_currency(dish.price) }}</p>
            </div>
          </div>
          <div class="content">
            {{ dish.description }}
          </div>
        </div>
        <footer class="card-footer">
          <a
            class="card-footer-item button is-primary"
            @click="select_dish(dish)"
          >
            Seleccionar
          </a>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import { warning_message, get, format_currency } from "@/utils";

export default {
  name: "FoodIndex",
  components: {},
  data() {
    return {
      dishes: [],
    };
  },
  methods: {
    format_currency,
    select_dish(dish) {
      this.$emit("dish-selected", dish);
    },
    get_dishes() {
      get("/restaurant/product/drinks", {})
        .then((response) => {
          this.dishes = this.dishes.concat(
            response.map((dish) => {
              return {
                plate_id: dish.plate_id,
                name: dish.name,
                price: dish.settings.price,
                description: dish.settings.description,
                image:
                  "https://www.laylita.com/recetas/wp-content/uploads/1-Ceviche-de-camaron.jpg",
              };
            })
          );
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
  mounted() {
    let v = this;
    v.get_dishes();
  },
  created() {},
};
</script>

<style scoped></style>
